<template>
<header class="header" v-bind:class="{ active: headerState }">
  <SectionCall
    v-if="callStat"
  />
  <div class="container">
    <div class="header__body">
      <button class="header__burger" @click="headerUpdate ()" v-bind:class="{ active: headerState }"><span></span></button>
      <div class="logo" v-bind:class="{ active: headerState }" @click="close()">
        <router-link :to=" { name: 'Home' } ">
          <picture>
            <source srcset="../../public/static/images/Logo.webp">
            <img src="../../public/static/images/Logo.png" alt="">
          </picture>
        </router-link>
      </div>
      <div class="header__icon" @click="openCall ()">
        <img src="../../public/static/icons/phone.svg" alt="">
      </div>
      <nav class="header__menu" v-bind:class="{ active: headerState }">
        <div class="header__logo" @click="headerFalse (); close()">
          <router-link :to=" { name: 'Home' } ">
          <picture>
            <source srcset="../../public/static/images/Logo.webp">
            <img src="../../public/static/images/Logo.png" alt="">
          </picture>
        </router-link>
        </div>
        <ul class="header__list">
          <li class="header__link" @click="headerFalse ()">
            <router-link :to=" { name: 'Home' } ">Главная</router-link>
          </li>
          <li class="header__link" @click="headerFalse ()">
            <router-link :to=" { name: 'Services' } ">Услуги</router-link>
          </li>
          <li class="header__link" @click="headerFalse ()">
            <router-link :to=" { name: 'Projects' } ">Проекты</router-link>
          </li>
          <li class="header__link" @click="headerFalse ()">
            <router-link :to=" { name: 'Contacts' } ">Контакты</router-link>
          </li>
          <li class="header__link" @click="headerFalse ()">
            <router-link :to=" { name: 'Company' } ">О компании gid</router-link>
          </li>
          <li class="header__link" @click="headerFalse ()">
            <router-link :to=" { name: 'Blog' } ">Блог</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</header>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import SectionCall from "@/components/SectionCall";
export default {
  name: "AppHeader",
  computed: {
    ...mapGetters([
        'headerState',
        'callStat'
    ])
  },
  components: {
    SectionCall
  },
  methods: {
    ...mapActions(['toggleHeaderState', 'falseHeaderState', 'closeCard', 'plusCall']),
    headerUpdate () {
      this.toggleHeaderState()
    },
    headerFalse () {
      this.falseHeaderState()
    },
    close() {
      this.closeCard()
    },
    openCall () {
      this.plusCall()
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 23;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    z-index: 21;
    transition: .2s linear all;
  }
  &.active {
    &:before {
      background-color: transparent;
    }
  }
  &__body {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 40px;
    padding: 14px 0;
  }
  .logo {
    z-index: 22;
    flex: 0 0 8rem;
    max-width: 8rem;
    overflow: hidden;
    opacity: 1;
    transition: .2s ease-in-out all;
    img {
      max-width: 100%;
      object-fit: contain;
      display: block;
      object-position: center;
    }
    &.active {
      opacity: 0;
      flex: 0 0 0;
      max-width: 0;
      cursor: unset;
    }
  }
  &__logo {
    z-index: 22;
    flex: 0 0 18rem;
    max-width: 18rem;
    overflow: hidden;
    margin-bottom: 30px;
    img {
      max-width: 100%;
      object-fit: contain;
      display: block;
      object-position: center;
    }
  }
  &__icon {
    z-index: 22;
    position: relative;
    width: 29px;
    height: 29px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
  }
  &__list {
    display: flex;
    position: relative;
    z-index: 22;
    flex-direction: column;
    text-align: center;
    li {
      margin-right: 0;
      margin-bottom: 6rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  &__link a {
    font-size: 3.6rem;
    font-weight: 300;
    color: #828282;
    padding: 2rem 3rem;
    &.router-link-exact-active {
      color: #fff;
      font-weight: 400;
      border: 1px solid #fff;
    }
    @media (max-width: 997.98px) {
      font-size: 2.4rem;
    }
  }
  &__burger {
    display: block;
    position: relative;
    width: 32px;
    height: 20px;
    border: none;
    background-color: transparent;
    z-index: 22;
    span {
      overflow: visible;
      position: absolute;
      width: 22px;
      height: 2px;
      top: 50%;
      left: 0;
      transform: translateY(-50%) scale(1);
      background-color: #BDBDBD;
      opacity: 1;
      transition: .2s linear all;
    }
    &:before, &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      left: 0;
      background-color: #BDBDBD;
      transition: .2s linear all;
    }
    &:before {
      top: 0;
    }
    &:after {
      bottom: 0;
    }
    &.active {
      span {
        transform: translateY(-50%) scale(0);
        opacity: 0;
      }
      &:before {
        top: 50%;
        transform: rotate(45deg) translateY(-50%);
      }
      &:after {
        bottom: 50%;
        transform: rotate(-45deg) translateY(50%);
      }
    }
  }
  &__menu {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0,0,0,.8);
    padding: 30px 20px 30px 20px;
    box-sizing: border-box;
    overflow: auto;
    opacity: 0;
    transition: .2s linear all;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: translateY(-100%);
    &.active {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
